var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[(_vm.isIdle)?_c('ModalIdle'):_vm._e(),_c('LicenseExpiredModal',{attrs:{"message":_vm.licenseExpiredMessage},model:{value:(_vm.licenseExpiredVisible),callback:function ($$v) {_vm.licenseExpiredVisible=$$v},expression:"licenseExpiredVisible"}}),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }